var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6748 2.82531C10.8863 3.03684 10.8863 3.37981 10.6748 3.59134L3.09143 11.1747C2.8799 11.3862 2.53693 11.3862 2.3254 11.1747C2.11386 10.9631 2.11386 10.6202 2.3254 10.4086L9.90873 2.82531C10.1203 2.61377 10.4632 2.61377 10.6748 2.82531Z",
    fill: "#576473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32548 2.82531C2.11395 3.03684 2.11395 3.37981 2.32548 3.59134L9.90881 11.1747C10.1203 11.3862 10.4633 11.3862 10.6748 11.1747C10.8864 10.9631 10.8864 10.6202 10.6748 10.4086L3.09151 2.82531C2.87998 2.61377 2.53701 2.61377 2.32548 2.82531Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIc);
export default __webpack_public_path__ + "static/media/cancel_ic.e2b6044e4da03f10ca00f74fea17f685.svg";
export { ForwardRef as ReactComponent };